import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import styles from './ActionsStrip.pcss'

export type ActionsStripAction = {
  icon: React.ReactNode,
  tooltip?: string,
  onClick: (event?: any) => any,
  className?: string,
  [dataAttr: `data-${string}`]: any
}

type ActionsStripProps = {
  actions: ActionsStripAction[],
  className?: string,
  'data-testid'?: string
}

export const ActionsStrip = (props: ActionsStripProps) => {
  return (
    <div className={`${styles['actions-strip']} ${props.className || ''}`} data-testid={props['data-testid']}>
      {props.actions.map((action, index) => {
        const { icon, tooltip, onClick, className, ...rest } = action
        const button = (
          <IconButton size="small" className={className} onClick={onClick} aria-label={tooltip} {...rest}>
            {icon}
          </IconButton>
        )
        if (tooltip) {
          return (
            <Tooltip key={index} title={tooltip}>
              {button}
            </Tooltip>
          )
        }
        return <React.Fragment key={index}>{button}</React.Fragment>
      })}
    </div>
  )
}
